import(/* webpackMode: "eager" */ "/workspace/src/app/(web)/error.tsx");
